import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Home, MessagesSquare, PlusCircle, MessageCircle, User as UserIcon, LogIn } from "lucide-react";

export default function BottomTabBar() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const items = user
    ? [
        { to: "/feed", label: "Gallery", icon: Home },
        { to: "/discuss", label: "Commons", icon: MessagesSquare },
        { to: "/create", label: "Share", icon: PlusCircle, primary: true },
        { to: "/messages", label: "Messages", icon: MessageCircle },
        { to: `/profile/${user.id}`, label: "You", icon: UserIcon },
      ]
    : [
        { to: "/feed", label: "Gallery", icon: Home },
        { to: "/discuss", label: "Commons", icon: MessagesSquare },
        { to: "/auth", label: "Sign in", icon: LogIn },
      ];

  return (
    <nav
      data-testid="bottom-tab-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 border-t border-border bg-background/90 backdrop-blur-xl"
    >
      <div className="flex items-center justify-around px-2 py-2">
        {items.map((it) => {
          const Icon = it.icon;
          const active = pathname === (it.match || it.to.split("?")[0]);
          return (
            <Link
              key={it.label}
              to={it.to}
              data-testid={`tab-${it.label.toLowerCase().replace(/\s+/g, "")}`}
              className="flex flex-col items-center gap-1 px-3 py-1"
            >
              <span
                className={`grid place-items-center ${
                  it.primary
                    ? "w-10 h-10 -mt-4 rounded-full bg-primary text-primary-foreground shadow-lg"
                    : active
                    ? "text-primary"
                    : "text-muted-foreground"
                }`}
              >
                <Icon size={it.primary ? 20 : 20} />
              </span>
              <span className={`text-[10px] ${active && !it.primary ? "text-primary" : "text-muted-foreground"}`}>
                {it.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
